/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgForm} from "@angular/forms";
import {AccidentPersonType} from "../../model/accident-person-type";
import {AccidentPersonTypeService} from "../../services/accident-person-type.service";
import {BaseNgFormAdminComponent} from '../../common/base-ngform-admin.component';

@Component({
    selector: 'app-accident-person-type',
    templateUrl: './accident-person-type.component.html',
    styleUrls: ['./accident-person-type.component.less'],
    standalone: false
})
export class AccidentPersonTypeComponent extends BaseNgFormAdminComponent implements OnInit {
  public accidentPersonTypes: AccidentPersonType[];

  constructor(private spinnerService: NgxSpinnerService,
              private accidentPersonTypeService: AccidentPersonTypeService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllAccidentPersonTypes();
  }

  protected reloadData(): void {
    this.getAllAccidentPersonTypes();
  }

  private getAllAccidentPersonTypes(){
    this.spinnerService.show();
    this.accidentPersonTypeService.getAll().subscribe(value => {
        this.accidentPersonTypes = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  addNew(newType: string){
    this.spinnerService.show();
    var newAccidentPersonType = new AccidentPersonType();
    newAccidentPersonType.type = newType;

    this.accidentPersonTypeService.addAccidentPersonType(newAccidentPersonType).subscribe(retVal=>{
      this.getAllAccidentPersonTypes();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding accident classification finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var accidentPersonTypeIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (accidentPersonTypeIds!=null && accidentPersonTypeIds.length>0)
    {
      accidentPersonTypeIds.forEach(vdi=>{
        var accidentPersonTypeChanged = this.accidentPersonTypes.find(x=>x.accidentPersonTypeId === vdi);
        this.accidentPersonTypeService.updateAccidentPersonTypeById(accidentPersonTypeChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllAccidentPersonTypes();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=accidentPersonTypeIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
    this.returnMessage = '';
    this.getAllAccidentPersonTypes();
    this.returnMessage = 'Updating accident classification finished';
    setTimeout(() => {
      this.returnMessage = '';
    }, 2000);
  }

}
